import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Avatar, Icon, Modal, Tooltip } from '@components/index';
import TruncateCell from '@components/truncate-cell/TruncateCell';
import { AccountType } from '@constants/generic';
import { MixpanelEventV2, sendMixpanelEventV2 } from '@core/analytics/mixpanel';
import { formatRoleDisplayName } from '@features/team-management/helpers/customRoles';
import { isOwnerOrOrgAdmin } from '@helpers/roleScope';
import EditOrganization from '@layouts/main-header/components/EditOrganization';

import theme from '../../../themes/colors';

const OrgDetails = () => {
  const { currentOrg } = useSelector((state: any) => state.user);

  const [showOrganizationDetailsModal, setShowOrganizationDetailsModal] =
    useState(false);

  const showOrgEditButton = isOwnerOrOrgAdmin(currentOrg);

  const onCancelModal = () => {
    setShowOrganizationDetailsModal(false);
  };

  const onOpenEditOrgModal = () => {
    sendMixpanelEventV2(MixpanelEventV2.ORG_LOGO_EDIT_OPENED);
    setShowOrganizationDetailsModal(true);
  };

  const disaplayName =
    currentOrg?.type === AccountType.INDIVIDUAL
      ? currentOrg?.display_name || ''
      : currentOrg?.name || '';

  const roleName = formatRoleDisplayName(currentOrg?.role_name ?? '');

  return (
    <div
      className={`flex items-start gap-2 py-4 pl-4 ${
        showOrgEditButton ? 'pr-1' : 'pr-4'
      }`}
    >
      <Avatar
        name={disaplayName}
        className="size-8 min-w-8 rounded-lg text-theme"
        imageUrl={currentOrg?.image_url}
        bgColor={theme.cofeePurple1}
        textClassName="text-lg font-medium text-cofeeNeutral10"
      />
      <div className="min-w-0 flex-1">
        <div className="flex w-full  items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <div className="truncate break-words font-medium text-cofeeNeutral10">
              {disaplayName}
            </div>
            {roleName ? (
              <div className="mt-0.5 text-xs font-medium text-cofeeNeutral7">
                <TruncateCell id="org-details-role-name" value={roleName} />
              </div>
            ) : null}
          </div>
          {showOrgEditButton && (
            <>
              <div
                className="flex !size-8 shrink-0 cursor-pointer items-center justify-center rounded-lg hover:bg-cofeeGreyBlue2"
                onClick={onOpenEditOrgModal}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    onOpenEditOrgModal();
                  }
                }}
                tabIndex={0}
                role="button"
                data-tooltip-id="edit-org-icon"
              >
                <Icon name="edit-pencil" size="16" />
              </div>
              <Tooltip id="edit-org-icon" type="text" tooltipText="Edit" />
            </>
          )}
        </div>
        {/* {roleName ? (
          <div className="mt-0.5 text-xs font-medium text-cofeeNeutral7">
            <TruncateCell id="org-details-role-name" value={roleName} />
          </div>
        ) : null} */}
      </div>
      {showOrganizationDetailsModal && (
        <Modal isOpen={showOrganizationDetailsModal} onCancel={onCancelModal}>
          <EditOrganization
            imageUrl={currentOrg?.image_url || ''}
            currentOrgName={disaplayName}
            currentOrgId={currentOrg?.id || ''}
            handleCancel={onCancelModal}
            accountType={currentOrg?.type || AccountType.ORGANIZATION}
          />
        </Modal>
      )}
    </div>
  );
};

export default OrgDetails;
